import React, { useContext, useState, Component } from "react";
import styled from "styled-components";

import PlaylistService from "../../service/playlist-service";
import { createOptions } from "./utils";
import View from "./view";
import IdleText from "./idle";
import Error from "../views/error";
import Loading from "../views/loading";
import { Box, Text, Col, Row, SearchBox, VGap } from "../../comps";
import { Theme } from "../../theme/theme-provider";

import { faPlus } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
  background: ${({ theme }) => theme.color.BLACK_0};
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.color.GRAY_2};
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.color.GRAY_1};
    border-radius: 20px;
  }
  &::-webkit-scrollbar-thumb:hover {
  }
`;

const HeadWrapper = styled(Row)`
  height: 50px;
  width: 100%;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.color.BLUE_4};
`;

const SearchBoxWrapper = styled(Box)`
  /* overflow: hidden; */
  width: 90%;
  height: 50px;
  margin-top: 30px;
`;

const STATUS = { IDLE: 0, LOADING: 1, SUCCESS: 2, ERROR: 3, CONVERT: 4 };

export default ({ modalData }) => {
  const [status, setStatus] = useState(STATUS.IDLE);
  const [list, setList] = useState({
    totalItems: 0,
    items: [],
    text: "",
    error: "",
  });

  const importUrl = async (url) => {
    if (status === STATUS.LOADING) return;
    setStatus(STATUS.LOADING);
    const payload = await PlaylistService.importUrl({ url });
    if (payload) {
      setList(payload);
      setStatus(payload.error ? STATUS.ERROR : STATUS.SUCCESS);
    } else {
      setStatus(STATUS.ERROR);
    }
  };

  const actions = createOptions({ list, setList, status, setStatus });

  return (
    <Wrapper>
      {modalData && (
        <HeadWrapper>
          <Text fontSize="28px" fontWeight="400" color={Theme.textColor.light}>
            {`Add Songs to ${modalData.to}`}
          </Text>
        </HeadWrapper>
      )}
      <SearchBoxWrapper>
        <SearchBox
          placeholder="Add a valid youtube or spotify playlist or song url"
          textColor="#d7e0da"
          background={Theme.color.GRAY_3}
          textAlign="center"
          fontSize="18px"
          buttonTextColor="#fff"
          buttonBackground={Theme.color.BLUE_5}
          buttonName="Import"
          buttonIcon={faPlus}
          buttonFontSize="16px"
          buttonRatio={30}
          onClick={importUrl}
        />
      </SearchBoxWrapper>
      {(status === STATUS.IDLE || status === STATUS.ERROR) && <IdleText />}
      {status === STATUS.ERROR && (
        <Error
          message={
            "Couldn't import this url. Make sure the video/playlist you are trying to import is public."
          }
        />
      )}
      {status === STATUS.LOADING && <Loading />}
      {(status === STATUS.SUCCESS || status === STATUS.CONVERT) && (
        <View list={list} modalData={modalData} actions={actions} />
      )}
    </Wrapper>
  );
};
